// Warranty date — the manufacturer warranty, quoted at whatever precision the
// warranty card actually shows: "2019", "07/2019" or "22/07/2019".
//
// Stored as a real DATE plus a precision marker (see App\Support\WarrantyDate).
// The forms edit it as plain text and send exactly what was typed; the backend
// re-detects the precision from the string, so there is no hidden precision
// field on any form to keep in step with the value.
//
// Deliberately NOT a date picker anywhere: a picker always yields a full day, so
// "2019" would be recorded as 1 January 2019 — a claim the warranty card does
// not make.

export const WARRANTY_DATE_PLACEHOLDER = "DD/MM/YYYY, MM/YYYY or YYYY";

/** Render the API's stored ISO date + precision back into the editable string. */
export const formatWarrantyDate = (isoDate, precision) => {
  if (!isoDate) return "";

  const [y, m, d] = String(isoDate).slice(0, 10).split("-");
  if (!y) return "";

  if (precision === "year") return y;
  if (precision === "month") return `${m}/${y}`;

  return `${d}/${m}/${y}`;
};
